"use client";
import { Fragment, useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@repo/ui/components/ui/select";
import { drop, parseCookies } from "@repo/ui/lib/utils";
import { useRouter } from "next/navigation";
import { useQueryClient } from "@tanstack/react-query";

const LanguageSwitcher = () => {
  const router = useRouter();
  const queryClient = useQueryClient();
  const [lang, setLang] = useState<string>();

  const langs = [
    { label: "Italiano", value: "it-IT" },
    { label: "English", value: "en-GB" },
  ];

  useEffect(() => {
    setLang(parseCookies()["NEXT_LOCALE"] || "it-IT");
  }, []);

  const switchLanguage = async (newLanguage: string) => {
    const domain = drop(location.hostname.split(".")).join(".");
    document.cookie = `NEXT_LOCALE=${newLanguage};domain=${domain};path=/`;
    await queryClient.invalidateQueries({ queryKey: ["category"] });
    await queryClient.invalidateQueries({ queryKey: ["faq"] });
    router.refresh();
    // window.location.reload();
  };

  return (
    <Select
      value={lang}
      onValueChange={(lang) => {
        setLang(lang);
        switchLanguage(lang);
      }}
    >
      <SelectTrigger
        variant="text"
        className="text-[20px] max-md:text-sm max-md:p-0 max-md:h-[14px] w-auto ml-2 gap-2 overflow-x-visible"
      >
        <SelectValue placeholder="Lingua" />
      </SelectTrigger>
      <SelectContent align="end" variant="rounded" className="z-50">
        {langs.map((l, i) => (
          <Fragment key={i}>
            <SelectItem variant="text" value={l.value}>
              {l.label}
            </SelectItem>
            {i < langs.length - 1 && <SelectSeparator />}
          </Fragment>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;
